import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchDashboard, fetchChildProgress, fetchChildDailyActivities, approveSkipRequest, rejectSkipRequest, fetchChildActivities, fetchChildActivityScores } from '../api/dashboard';

export const useDashboard = () => {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: fetchDashboard,
    staleTime: 0, // Always consider data stale to ensure fresh data after edits
    refetchOnWindowFocus: true,
    refetchOnMount: true, // Always refetch when component mounts
  });
};

export const useApproveSkipRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approveSkipRequest,
    onSuccess: () => {
      // Refetch dashboard data after approval
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
};

export const useRejectSkipRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rejectSkipRequest,
    onSuccess: () => {
      // Refetch dashboard data after rejection
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
};

export const useChildProgress = (childId, enabled = false) => {
  return useQuery({
    queryKey: ['childProgress', childId],
    queryFn: () => fetchChildProgress(childId),
    enabled: enabled && !!childId,
    staleTime: 60000, // 1 minute
  });
};

export const useChildDailyActivities = (childId, date, enabled = false) => {
  return useQuery({
    queryKey: ['childDailyActivities', childId, date],
    queryFn: () => fetchChildDailyActivities(childId, date),
    enabled: enabled && !!childId && !!date,
    staleTime: 60000, // 1 minute
  });
};

export const useChildActivities = (childId, enabled = false) => {
  return useQuery({
    queryKey: ['childActivities', childId],
    queryFn: () => fetchChildActivities(childId),
    enabled: enabled && !!childId,
    staleTime: 60000, // 1 minute
  });
};

export const useChildActivityScores = (childId, activityId, enabled = false) => {
  return useQuery({
    queryKey: ['childActivityScores', childId, activityId],
    queryFn: () => fetchChildActivityScores(childId, activityId),
    enabled: enabled && !!childId && !!activityId,
    staleTime: 60000, // 1 minute
  });
};
